// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul{margin-bottom:unset!important}.app__MLDocuments__button-margin{margin-right:20px}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-gateway-react/Policies/MLDocuments/MLDocuments.module.scss"],"names":[],"mappings":"AAAA,GACI,6BAAA,CAGJ,iCACI,iBAAA","sourcesContent":["ul {\n    margin-bottom: unset !important;\n}\n\n.button-margin {\n    margin-right: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button-margin": "app__MLDocuments__button-margin"
};
export default ___CSS_LOADER_EXPORT___;
